import { delayedCall, dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { StackSymbolFeatureController } from "@quest/murka-games-behavior-panther/dist/Game/StackFeature/StackSymbolFeatureController";
import { StackSymbolFeatureView } from "@quest/murka-games-behavior-panther/dist/Game/StackFeature/StackSymbolFeatureView";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class StackSymbolFeatureControllerGame extends StackSymbolFeatureController {
  constructor(view: StackSymbolFeatureView) {
    super(view);
    this.stackAnimation = "symbol_character";
  }

  // Overrided to subscribe game end function
  protected subscribeEvent(): void {
    this.unSubscribeEvent();
    dispatcher.on(SlotEventConstantsBehavior.SHOW_LARGE_STACK_SYMBOL, this.showLargeStackSymbol, this);
    dispatcher.on(SlotEventConstantsBehavior.HIDE_LARGE_STACK_SYMBOL, this.resetElements, this);
    dispatcher.on(SlotEventConstantsBehavior.PLAY_STACK_SYM_ANIM, this.playStackSymAnimation, this);
    dispatcher.on(SlotEventConstantsBehavior.STOP_STACK_SYM_ANIM, this.stopStackSymAnimation, this);
    dispatcher.on(SlotEventConstantsBehavior.PLAY_STACK_WIN_ANIMATION_ON_TOGGLE, this.playStackWinLineAnim, this);
  }

  // Overrided to un subscribe game end function
  protected unSubscribeEvent(): void {
    dispatcher.off(SlotEventConstantsBehavior.SHOW_LARGE_STACK_SYMBOL, this.showLargeStackSymbol, this);
    dispatcher.off(SlotEventConstantsBehavior.HIDE_LARGE_STACK_SYMBOL, this.resetElements, this);
    dispatcher.off(SlotEventConstantsBehavior.PLAY_STACK_SYM_ANIM, this.playStackSymAnimation, this);
    dispatcher.off(SlotEventConstantsBehavior.STOP_STACK_SYM_ANIM, this.stopStackSymAnimation, this);
    dispatcher.off(SlotEventConstantsBehavior.PLAY_STACK_WIN_ANIMATION_ON_TOGGLE, this.playStackWinLineAnim, this);
  }

  // Overrided to play stack symbols win sound
  protected playStackSymAnimation(): void {
    super.playStackSymAnimation();
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.SYMBOLS_STACK_WIN_SOUND,
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_PRELOAD
    );
  }

  protected playStackSpineAnim(reel: number, numOfSingleSym: number, col: number): void {
    const StackSpinePlayDelayTime = 600;
    if (numOfSingleSym != 1) {
      const spineContainer = this.view.getContainerByID(`Reel${reel}_1x4_Container`);
      const cloneSpine = this.view.getSpineJsonAndCloneSym(this.stackTransition);
      cloneSpine.y = this.view.json.symHeight * col;
      spineContainer.addChild(cloneSpine);
      cloneSpine.visible = true;
      cloneSpine.playAnim(`1x${numOfSingleSym}_blast`, false);
      // StackSpinePlayDelay is used to play spine with little delay after the transition spine start playing.
      delayedCall(
        "StackSpinePlayDelay" + reel + col,
        StackSpinePlayDelayTime,
        () => {
          this.cloneSpineForAnim = spineContainer.children[0];
          this.stackAnimationArray[reel - 1] = [
            this.cloneSpineForAnim,
            `Character_1X${numOfSingleSym}_Static`,
            `Character_1X${numOfSingleSym}`,
          ];
          this.cloneSpineForAnim.visible = true;
          this.cloneSpineForAnim.playAnim(`Character_1X${numOfSingleSym}`, true);
        },
        this
      );
    }
  }

  /**
   * to play win line animation of stack symbol
   */
  private playStackWinLineAnim(evt: IEvent) {
    this.stopStackSymAnimation();
    const currentWinLineOffset: number[][] = evt.data;
    for (let i: number = 0; i < currentWinLineOffset.length; i++) {
      const commonOffset = (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin();
      for (let j: number = 0; j < commonOffset.length; j++) {
        for (let k: number = 0; k < commonOffset[j].length; k++) {
          if (currentWinLineOffset[i][0] === commonOffset[j][k][0] && currentWinLineOffset[i][1] === commonOffset[j][k][1]) {
            const stackReelId = currentWinLineOffset[i][0];
            let stackAnimArray = this.stackAnimationArray[stackReelId];
            stackAnimArray && stackAnimArray[0].playAnim(stackAnimArray[2], true);
            break;
          }
        }
      }
    }
  }

  /**
   * Overrided to stop stack animation
   */
  stopStackSymAnimation() {
    this.stackAnimationArray.length != 0 &&
      this.stackAnimationArray.forEach((data) => {
        data && data[0].playAnim(data[1], false);
      }, this);
  }

  /**
   * Overrided to play stack animation
   */
  playStackWinLineAnimation() {
    this.stackAnimationArray.length &&
      this.stackAnimationArray.forEach((data) => {
        data && data[0].playAnim(data[2], true);
      }, this);
  }
}
